import { render, staticRenderFns } from "./HealthDetail.vue?vue&type=template&id=c5c46d7c&scoped=true&"
import script from "./HealthDetail.vue?vue&type=script&lang=js&"
export * from "./HealthDetail.vue?vue&type=script&lang=js&"
import style0 from "./HealthDetail.vue?vue&type=style&index=0&id=c5c46d7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c46d7c",
  null
  
)

component.options.__file = "HealthDetail.vue"
export default component.exports